<style lang="scss">
.waiting-room-page {
  &__title {
    @include mobile-portrait() {
      margin-top: 25px !important;
    }
  }

  .profile-img {
    border-radius: 100%;
    width: 120px;
    height: 120px;
    object-fit: cover;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <div class="theme-color-wrapper p-2">
    <div class="waiting-room-page row max-page-width-small mb-4">
      <div class="col-12">
        <section class="waiting-room-page__title mb-3">
          <h2 class="font-weight-bolder mb-1">Waiting Room</h2>

          <router-link :to="{ name: 'dashboard' }" v-if="!isIntakeUser">
            &laquo; Back to calls
          </router-link>
        </section>

        <section v-if="!loading && call && visitor">
          <section class="mb-2 d-flex justify-content-center">
            <img class="profile-img" :src="visitor.profile_picture_url || placeholder" width="60px" alt="contact image">
          </section>

          <section class="mb-2">
            <h4 class="font-weight-bolder">Caller</h4>
            <p cy="caller">{{ call.prisoner.firstname }} {{ call.prisoner.lastname }}</p>
          </section>

          <section class="mb-2">
            <h4 class="font-weight-bolder">Date & Time</h4>
            <p cy="date">{{ call.booked_slot.start_date_time | formatDate }} @
              {{ call.booked_slot.slot_begin }} - {{ call.booked_slot.slot_end }}</p>
          </section>

          <section>
            <h4 class="font-weight-bolder">Call Reminder</h4>
            <p>Please remember that only approved participants are permitted to be on this call,
              if an unapproved participant is detected your call may be terminated and you may lose the ability to have
              calls in the future.
            </p>

            <p>Please note: This call may be monitored by a member of staff. Monitoring staff
              will be able to both hear and see you and your caller.
            </p>
          </section>

          <section>
            <h4 class="font-weight-bolder">Call Waiting</h4>
            <p>You are now in the waiting room. When {{ call.prisoner.firstname }} is ready you will be able to
              join.</p>
            <p>Please take some time to read any messages or announcements below.</p>
          </section>

          <section class="mt-4" cy="announcement-waiting" v-if="announcement">
            <announcement key="main-announcement" :announcement="announcement"></announcement>
          </section>

          <section class="d-flex justify-content-end">
            <b-btn class="ml-1" :to="{ name: 'live-call', params: { visitId: call._id, prisonerNumber: call.prisoner.prisoner_number }}"
                   :class="{'disabled': !isCallReady(call)}" variant="primary"><span class="fas fa-camera"></span> Enter
              Call
            </b-btn>
          </section>

        </section>

        <section v-else>
          <b-spinner variant="primary" label="Loading"></b-spinner>
        </section>
      </div>
    </div>

    <b-modal id="modal-announcement" title="Pre Call Announcement" hide-footer>
      <announcement v-if="announcementPreCall"
                    key="pre-announcement" :announcement="announcementPreCall"></announcement>
    </b-modal>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState, mapGetters } from 'vuex';
import AnnouncementsService from '@/services/AnnouncementsService';
import VisitorUsersService from '@/services/OffsiteUsersService';
import Announcement from '@/components/announcement/Annoucement.vue';
import VisitsService from '@/services/VisitsService';

export default {
  name: 'WaitingRoom',
  components: {
    Announcement,
  },
  data() {
    return {
      id: null,
      loading: false,
      // eslint-disable-next-line global-require
      placeholder: require('../../assets/images/id/placeholder.png'),
      announcement: null,
      announcementPreCall: null,
      intervalPoll: '',
      visitor: null,
      reminderSent: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      call: state => state.myCalls.call,
    }),
    ...mapGetters('auth', { isIntakeUser: 'isIntakeUser' }),
  },
  mounted() {
    this.id = this.$route.params.id;
    this.loading = true; // loading here as call is polled so not set in fn
    this.getCall();
    this.pollItems();
  },
  beforeDestroy() {
    clearInterval(this.intervalPoll);
    this.updateWaitingRoomStatus(false);
  },
  methods: {
    getCall() {
      this.$store.dispatch('myCalls/refreshCall', this.id).then(() => {
        // redirect
        if (this.call.status !== 'Approved') {
          if (this.isIntakeUser) {
            this.$router.push({ name: 'call-ended' });
          } else {
            this.$router.push({ name: 'dashboard' });
          }
        }

        if (this.loading) { // only do on first load
          this.getAnnouncementsForWaitingRoom();
          this.getPrecallAnnouncements();
          this.getVisitor();
        }

        this.loading = false;
      }).catch(error => {
        console.log('error', error);
        this.$toast.error('Could not get call, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      })
    },
    getAnnouncementsForWaitingRoom() {
      AnnouncementsService.getAnnouncementMotdAd(this.call.prison.prison_id).then(res => {
        if (res.data) {
          this.announcement = res.data;
        }
      });
    },
    getPrecallAnnouncements() {
      AnnouncementsService.checkPreCallAnnouncements(this.call.prison.prison_id).then(res => {
        if (res.data) {
          this.announcementPreCall = res.data;
          // this.$bvModal.show('modal-announcement');
        }
      });
    },
    closeModals() {
      this.$bvModal.hide('modal-announcement');
    },
    pollItems() {
      this.intervalPoll = setInterval(() => {
        this.getCall();
      }, 10000);
    },
    updateWaitingRoomStatus(inRoom) {
      VisitsService.updateWaitingRoomStatus(this.id, {
        visitor_in_waiting_room: inRoom,
      }).then(res => res);
    },
    isCallReady(call) {
      if (call) {
        const callSecurityJoined = call.call_state.call_security_joined || false;
        const waitingRoomOrInCall = call.call_state.prisoner_in_call;
        return callSecurityJoined && waitingRoomOrInCall;
      }
      return false;
    },
    getVisitor() {
      VisitorUsersService.getUser(this.call.visitor.user_id).then(res => {
        this.visitor = res.data;
        this.updateWaitingRoomStatus(true);
      }).catch(() => {
        this.$toast.error('Could not get call information, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      })
    },
  },
}
</script>
